import { client } from '../apolloClient';
import { WizardHeartbeatDocument, WizardHeartbeatMutation } from './queryTyping/wizardHeartbeat';
import { useHeartbeat } from './useHeartbeat';

function callWizardHeartbeatMutation() {
  client.mutate<WizardHeartbeatMutation>({
    mutation: WizardHeartbeatDocument,
    fetchPolicy: 'no-cache',
  });
}

export const useWizardHeartbeat = (sessionExpirationInSecs: number | undefined) => {
  useHeartbeat(() => (true), callWizardHeartbeatMutation, sessionExpirationInSecs);
};
